import { defineMessages } from 'dibs-react-intl';

// components
import { SbMobileRefineMenuFilterPrice } from './SbMobileRefineMenuFilterPrice';
import { SbMobileRefineMenuFilterStoneCut } from './SbMobileRefineMenuFilterStoneCut';
import { SbMobileRefineMenuFilterCategory } from './SbMobileRefineMenuFilterCategory';
import { SbMobileRefineMenuFilterDimensions } from './SbMobileRefineMenuFilterDimensions';
import { SbMobileRefineMenuFilterCaratWeight } from './SbMobileRefineMenuFilterCaratWeight';
import { SbMobileRefineMenuFilterDeliveryOptions } from './SbMobileRefineMenuFilterDeliveryOptions';
import { sbSharedRefineMenuFiltersMap } from '../../SbSharedRefineMenu/SbSharedRefineMenuFilters/sbSharedRefineMenuFiltersMap';

const titleOverrides = defineMessages({
    dimensions: {
        id: 'sb.SbMobileRefineMenuFilterDimension.title',
        defaultMessage: 'Dimensions',
    },
    location: {
        id: 'sb.SbMobileRefineMenuFilterDeliveryOptions.title',
        defaultMessage: 'Shipping Options',
    },
});

export const sbMobileRefineMenuFiltersMap = Object.assign({}, sbSharedRefineMenuFiltersMap, {
    'carat-weight': {
        component: SbMobileRefineMenuFilterCaratWeight,
    },
    categoryL1: {
        component: SbMobileRefineMenuFilterCategory,
    },
    height: {
        component: SbMobileRefineMenuFilterDimensions,
        title: titleOverrides.dimensions,
    },
    width: {
        component: SbMobileRefineMenuFilterDimensions,
        title: titleOverrides.dimensions,
    },
    length: {
        component: SbMobileRefineMenuFilterDimensions,
        title: titleOverrides.dimensions,
    },
    depth: {
        component: SbMobileRefineMenuFilterDimensions,
        title: titleOverrides.dimensions,
    },
    price: {
        component: SbMobileRefineMenuFilterPrice,
    },
    priceTrade: {
        component: SbMobileRefineMenuFilterPrice,
    },
    'stone-cut': {
        component: SbMobileRefineMenuFilterStoneCut,
    },
    location: {
        component: SbMobileRefineMenuFilterDeliveryOptions,
        title: titleOverrides.location,
    },
    gallery: {
        component: null,
    },
    latest: {
        component: null,
        isBatchAppliedFilter: true,
    },
    sale: {
        component: null,
        isBatchAppliedFilter: true,
    },
    customizable: {
        component: null,
        isBatchAppliedFilter: true,
    },
    'net-price': {
        component: null,
        isBatchAppliedFilter: true,
    },
    returnable: {
        component: null,
        isBatchAppliedFilter: true,
    },
    recognized: {
        component: null,
        isBatchAppliedFilter: true,
    },
    topSeller: {
        component: null,
        isBatchAppliedFilter: true,
    },
    isSellerStrategicPartner: {
        component: null,
        isBatchAppliedFilter: true,
    },
});

export const getValidMobileAppliedFilters = function ({ appliedFilters = [] }) {
    return appliedFilters.filter(filter => filter.canBeDismissed);
};

export const isBatchAppliedFilter = filterName =>
    sbMobileRefineMenuFiltersMap[filterName] &&
    !!sbMobileRefineMenuFiltersMap[filterName].isBatchAppliedFilter;
